var render = function (_h,_vm) {var _c=_vm._c;return _c('span',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass, 'sf-chevron'],style:([_vm.data.style, _vm.data.staticStyle])},'span',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }